import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {WifiSubscriptionService, WifiSubscriptionWithAuthenticationDto} from '../../../../_services/configuration-services';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';
import {TranslateUtils} from '../../../../_shared/translate-utils';

@Component({
    selector: 'app-wifi-subscription-list-for-customer',
    templateUrl: './wifi-subscription-list-for-customer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WifiSubscriptionListForCustomerComponent implements OnInit, OnDestroy {

    crtLang = TranslateUtils.defaultLanguage;

    wifiCustomerSubscriptions: WifiSubscriptionWithAuthenticationDto[] = [];

    private langChangeSubscription: Subscription;

    constructor(
        private readonly wifiSubscriptionService: WifiSubscriptionService,
        private readonly translateService: TranslateService,
    ) {
    }

    ngOnInit(): void {
        this.crtLang = this.translateService.currentLang;
        this.langChangeSubscription = this.translateService.onLangChange.subscribe(async (event: LangChangeEvent) => {
            this.crtLang = event.lang;
        });

        this.fetchWifiSubscriptions();
    }

    ngOnDestroy(): void {
        this.langChangeSubscription.unsubscribe();
    }

    getServiceName(wifiSubscription: WifiSubscriptionWithAuthenticationDto): string {
        return wifiSubscription['serviceName' + this.crtLang.toUpperCase()];
    }

    getDisplayDateFormat(): string {
        return this.translateService.instant('common.period.dateTimeFormat');
    }

    private fetchWifiSubscriptions(): void {
        this.wifiSubscriptionService.getMySubscriptions().pipe().subscribe(result => {
            this.wifiCustomerSubscriptions = result;
        });
    }

}
